import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Config } from '../../config';

@Component({
  selector: 'app-calendar-event-files',
  templateUrl: './calendar-event-files.component.html',
  styleUrls: ['./calendar-event-files.component.css']
})
export class CalendarEventFilesComponent implements OnInit {

  public routeParams: string;
  public config = new Config();
  public configURLexcept_Api: string = ""
  constructor(private router: Router,
  private route: ActivatedRoute) { }

  ngOnInit() {
    console.log("Calender has been downloaded");
    var apiUrlArray = this.config.apiUrl.split("/");
    for(let i=0; i<apiUrlArray.length; i++){
      if(apiUrlArray[i] === "" || apiUrlArray[i] === "api" || apiUrlArray[i] === "v1" || apiUrlArray[i]==="https:"){
      }else{
        this.configURLexcept_Api = this.configURLexcept_Api + apiUrlArray[i];
      }
    }

    this.route.queryParams.subscribe((params) => {
      this.routeParams = params["file_id"]
      // window.location.hostname = this.configURLexcept_Api;
      window.location.href = "https://" + this.configURLexcept_Api + "/CalendarEventFiles/" + this.routeParams;
      // window.open(this.configURLexcept_Api + "/CalendarEventFiles/" + this.routeParams, "_blank");
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/calendar-event-files/calendar-event-files.component.ts